import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { Subject } from 'rxjs';

@Injectable()
export class AlertsService {
  dataChanged = new Subject<boolean>();

  constructor(private http: HttpClient) { }
  getAlerts() {
    console.log(environment.communication_service_api + "alert/full_list_alerts")
    return this.http.get(environment.communication_service_api + "alert/full_list_alerts")
  }
  insertAlert(agentId,param){
    return this.http.post(environment.communication_service_api+"alert/"+agentId+"/set_alerts",param)
  }
  listAlerts(agentId) {
    
    return this.http.get(environment.communication_service_api + "alert/"+agentId+"/get_all_alerts")
  }
  updateAlert(agentId,alertId,params){

    return this.http.put(environment.communication_service_api + "alert/"+agentId+"/"+alertId+"/update_alert",params)

  }
  deleteAlert(agentId,alertId){

    return this.http.delete(environment.communication_service_api + "alert/"+agentId+"/"+alertId)

  }
  getAlertData(agentId,alertId) {
    
    return this.http.get(environment.communication_service_api + "alert/"+agentId+"/"+alertId)
  }

}
